module.exports = __webpack_public_path__ + "static/media/full-logo.aa7493d9.png";